import { useMonarchRule } from "../MonarchRulesProvider";
import { DegreeTYPageData } from "./types";

const CUSTOM_RULE_ID = "degreeTyPage";

const useDegreeTYPage = () => {
  const { isLoading, value } = useMonarchRule<{
    data: DegreeTYPageData;
    variantCustomId: string;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading) {
    return {
      isLoading,
      header: undefined,
      crossSellSection: undefined,
      applyInstructionsSection: undefined,
      redirectToPartnerTyPage: undefined,
      routeFlag: undefined,
    };
  }

  return {
    isLoading,
    header: value?.data?.header,
    crossSellSection: value?.data?.crossSellSection,
    applyInstructionsSection: value?.data?.applyInstructionsSection,
    redirectToPartnerTyPage: value?.data?.redirectToPartnerTyPage,
    routeFlag: value?.data?.routeFlag,
  };
};

export default useDegreeTYPage;
